import { h } from 'preact'
import cx from '../../shared/classes'
import { closeWidget } from '../../shared/utils'
import globalVars from '../../shared/global'
import * as style from './style.css'

interface Props {
    steps: number[]
    currentStep: number
    titles: string[]
    showSteps?: boolean
}

const Header: preact.FunctionalComponent<Props> = ({ steps, currentStep, titles, showSteps = !globalVars.isRSVP }) => {
    return (
        <header class={style.header}>
            {globalVars.isMounted && <div class={style.headerClose} onClick={closeWidget} />}

            {showSteps && (
                <ul class={style.steps} role="progressbar">
                    {steps.map((step) => (
                        <li
                            key={step}
                            class={cx({
                                [style.step]: true,
                                [style.stepActive]: step <= currentStep,
                                [style.stepCompleted]: step < currentStep,
                            })}
                        />
                    ))}
                </ul>
            )}
            <h1>{titles[currentStep]}</h1>
        </header>
    )
}

export default Header
